import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { OutletSubType } from "@/app/services/generated/outletsubtypeService";
import { outletSubTypeService } from "@/app/services/generated/outletsubtypeService";

export interface IHasOutletSubTypesCache {
  outletSubTypes: OutletSubTypesCache;
}

// Singleton cache store
const outletSubTypesCacheStore = new EntityCacheStore<OutletSubType>(
  EnumCacheEntityType.outletSubType,
  async () => outletSubTypeService.getAllOutletSubTypes()
);

// Ephemeral reader
export default class OutletSubTypesCache extends EntityWithGuidKeyCache<OutletSubType> {
  constructor() {
    super(outletSubTypesCacheStore, (x) => x.id);
  }
}
